import { type FirebaseOptions, getApp, initializeApp } from 'firebase/app'

const firebaseConfig = {
	apiKey:
		process.env.EXPO_PUBLIC_FIREBASE_API_KEY ||
		process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
	appId:
		process.env.EXPO_PUBLIC_FIREBASE_APP_ID ||
		process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
	authDomain:
		process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN ||
		process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
	databaseURL: `https://${process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID}-default-rtdb.europe-west1.firebasedatabase.app`,
	measurementId:
		process.env.EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID ||
		process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
	messagingSenderId:
		process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ||
		process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
	projectId:
		process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID ||
		process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
	storageBucket:
		process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET ||
		process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
}

export const getFirebaseApp = (config: FirebaseOptions = firebaseConfig) => {
	try {
		return getApp()
	} catch {
		return initializeApp(config)
	}
}

export { getUser, getUserToken } from '../auth/utils'
